import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const productService = { getAllProducts, getProduct }

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.itemCode) params.item_code = filter.itemCode
  if (filter?.includeHidden) params.include_hidden = 1
  filter?.searchArray?.forEach((w, i) => {
    if (w !== null && w !== '') params[`search_words[${i}]`] = w
  })
  return params
}

export function getAllProducts(filter) {
  return apiHelper(API_URL).get('/products', { params: buildParams(filter) })
}
export function getProduct(itemCode) {
  return apiHelper(API_URL).get(`/products/${itemCode}`)
}
